<template>
  <v-dialog v-model="dialogVisible" max-width="500px">
    <v-card>
      <v-card-title><span class="text-h6">Keyword</span></v-card-title>
      <v-card-text>
        <v-list-item>
          <v-list-item-avatar color="#EDF4FB">
            <v-icon color="#439EDF" dark>
              mdi-account-outline
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Created By</v-list-item-title>
            <v-list-item-subtitle>{{createnamekeyword}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-avatar color="#EDF4FB">
            <v-icon color="#439EDF" dark>
              mdi-clock-outline
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Created Date</v-list-item-title>
            <v-list-item-subtitle>{{createdatekeyword}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-avatar color="#EDF4FB">
            <v-icon color="#439EDF" dark>
              mdi-account-reactivate-outline
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Update By</v-list-item-title>
            <v-list-item-subtitle>{{updatenamekeyword}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
        <v-list-item>
          <v-list-item-avatar color="#EDF4FB">
            <v-icon color="#439EDF" dark>
              mdi-history
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Update Date</v-list-item-title>
            <v-list-item-subtitle>{{updatedatekeyword}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
      </v-card-text>
      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    createnamekeyword: { type: String, default: '' },
    createdatekeyword: { type: String, default: '' },
    updatenamekeyword: { type: String, default: '' },
    updatedatekeyword: { type: String, default: '' }
  },
  computed: {
    dialogVisible: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    close() {
      this.dialogVisible = false
    }
  }
}
</script>
